// extracted by mini-css-extract-plugin
module.exports = {"requested":"styles_requested__2WaT3","content":"styles_content__yzKIf"};